/* eslint-disable complexity */
/* eslint-disable max-statements */
import { BlueprintInstanceType, ConnectionHalfParams, HorizontalAlignment, Island, Panel, VerticalAlignment } from '..';
import { Obstruction } from '../blueprint-classes/obstructions/obstruction.class';

export type ConnectIslandParams = {
	sourcePanel: Panel | null;
	targetPanel: Panel | null;
	offset?: number;
	padding?: number;
};

export const connectIslands = (params: ConnectIslandParams): void => {
	const { sourcePanel, targetPanel, offset = 0, padding = 1 } = params;

	if (sourcePanel === null || targetPanel === null) {
		console.warn('connectIslands:missing source and/or target panel', params);
		return;
	}

	// console.log('connectIslands: panels found', { sourcePanel: sourcePanel.id, targetPanel: targetPanel.id });

	const sourceIsland = (sourcePanel.findParentInstanceOf(BlueprintInstanceType.Island) ||
		sourcePanel.findParentInstanceOf(BlueprintInstanceType.Obstruction)) as unknown as Island | Obstruction;
	const targetIsland = (targetPanel.findParentInstanceOf(BlueprintInstanceType.Island) ||
		targetPanel.findParentInstanceOf(BlueprintInstanceType.Obstruction)) as unknown as Island | Obstruction;

	// console.log('connectIslands: islands found', {
	// 	sourceIsland: sourceIsland?.id,
	// 	targetIsland: targetIsland?.id,
	// 	sourceType: sourceIsland?._instanceType,
	// 	targetType: targetIsland?._instanceType
	// });

	if (!sourceIsland || !targetIsland) {
		console.error('connectIslands: Could not find parent island/obstruction', { sourceIsland, targetIsland });
		return;
	}

	let hSourceAlign = HorizontalAlignment.right;
	let hTargetAlign = HorizontalAlignment.left;

	if (sourcePanel.isFrontPanel && targetPanel.isFrontPanel) {
		hSourceAlign = HorizontalAlignment.center;
		hTargetAlign = HorizontalAlignment.center;
	} else if (sourceIsland.axis.y === targetIsland.axis.y) {
		if (sourcePanel.isRightPanel) {
			hSourceAlign = HorizontalAlignment.left;
			hTargetAlign = HorizontalAlignment.right;
		}
	// deepcode ignore DuplicateIfBody: <please specify a reason of ignoring this>
	} else if (targetIsland.isCornerIsland) {
		if (sourcePanel.isRightPanel) {
			hSourceAlign = HorizontalAlignment.left;
			hTargetAlign = HorizontalAlignment.right;
		// file deepcode ignore DuplicateIfBody: <please specify a reason of ignoring this>
		} else if (targetPanel.isRightPanel && sourcePanel.isFrontPanel) {
			hSourceAlign = HorizontalAlignment.left;
			hTargetAlign = HorizontalAlignment.right;
		}
	// deepcode ignore DuplicateIfBody: <please specify a reason of ignoring this>
	} else if (sourceIsland.isCornerIsland) {
		if (sourcePanel.isRightPanel) {
			hSourceAlign = HorizontalAlignment.left;
			hTargetAlign = HorizontalAlignment.right;
		}
	} else if (sourcePanel.isFrontPanel && targetPanel.isRightPanel) {
		hSourceAlign = HorizontalAlignment.left;
		hTargetAlign = HorizontalAlignment.right;
	}

	const sourceConnection: ConnectionHalfParams = {
		verticalAlignment: VerticalAlignment.bottom,
		horizontalAlignment: hSourceAlign,
		alignToPanel: sourceIsland.isCornerIsland || targetIsland.isCornerIsland,
		panelId: sourcePanel.id,
		islandId: sourceIsland.id,
		panel: sourcePanel
	};
	const targetConnection: ConnectionHalfParams = {
		verticalAlignment: VerticalAlignment.bottom,
		horizontalAlignment: hTargetAlign,
		alignToPanel: sourceIsland.isCornerIsland || targetIsland.isCornerIsland,
		panelId: targetPanel.id,
		islandId: targetIsland.id,
		panel: targetPanel
	};

	// console.log('connectIslands', {
	// 	sourcePanel: sourcePanel.id,
	// 	targetPanel: targetPanel.id,
	// 	sourceIsland: sourceIsland.id,
	// 	targetIsland: targetIsland.id
	// });

	sourceIsland.connections.newConnection(sourceConnection, targetConnection, { padding, offset });
};
